import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

import sitlogo from '../../assets/images/sitlogo.png'
import { ListItem } from "@mui/material";
Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: '/fonts/Poppins-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/Poppins-SemiBold.ttf',
            fontWeight: 600,
        },
        {
            src: '/fonts/Poppins-Bold.ttf',
            fontWeight: 'bold',
        },
    ],
});

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
    },
    col: {
        display: "flex",
        flexDirection: "row",
        //border: "1px solid black",
    }
});

const PaymentCollectionDoc = ({ data }) => {

    const paymentcollected = Array.isArray(data) ? data : [];
    return (
        <Document>
            <Page size="A4" style={{ padding: 30, fontSize: 10, }}>
                <View
                    style={{
                        flexDirection: 'column',
                        justifyContent: "space-between",
                        alignItems: "flex-start",

                    }}>
                    <Image src={sitlogo} style={{ width: "70px" }}>
                    </Image>
                </View>

                <View style={{ fontSize: "10px", textAlign: "center", }}>
                    <Text style={{ fontFamily: "Poppins", fontWeight: 'bold' }}>Detail Payment Collection Report Year : 2024</Text>
                </View>

                <View style={[styles.col, { border: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>
                    <View style={{ borderRight: "1px solid black", width: "40%" }}>
                        <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Training Programme / Batch</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "20%" }}>
                        <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Total Fees</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "20%" }}>
                        <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Fees Received</Text>
                    </View>
                    <View style={{ width: "20%" }}>
                        <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Collection(%)</Text>
                    </View>

                </View>
                {paymentcollected.map((item, index) => (
                    <View style={[styles.col, { borderBottom: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>

                        <View style={{ borderRight: "1px solid black", borderLeft: "1px solid black", width: "40%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Course_Name}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "20%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Total_Fees_Full_Payment} </Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "20%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Total_Amount}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "20%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Collection}</Text>
                        </View>
                    </View>
                ))}
            </Page>
        </Document>


    )
}

export default PaymentCollectionDoc